import React from 'react';
import { ExternalLink } from 'lucide-react';

// All listings verified from Krystle Roth's Zillow profile (Apr 2026 snapshot).
// https://www.zillow.com/profile/RothGetsResults
const activeListings = [{
  address: '31397 Mesa Dr',
  city: 'Redlands, CA 92373',
  price: '$850,000',
  beds: 4,
  baths: 3,
  status: 'For Sale'
}, {
  address: '34972 S Serrano Sq',
  city: 'Yucaipa, CA 92399',
  price: '$879,000',
  beds: 4,
  baths: 3,
  status: 'For Sale'
}];
const recentSales = [{
  address: '31015 Sutherland Dr',
  city: 'Redlands, CA 92373',
  price: '$1,040,000',
  date: '3/9/2026',
  side: 'Seller'
}, {
  address: '1400 Elizabeth St',
  city: 'Redlands, CA 92373',
  price: '$849,000',
  date: '3/3/2026',
  side: 'Seller'
}, {
  address: '608 Monterey St',
  city: 'Redlands, CA 92373',
  price: '$610,000',
  date: '2/23/2026',
  side: 'Seller'
}, {
  address: '442 E Sunset Dr N',
  city: 'Redlands, CA 92373',
  price: '$789,900',
  date: '2/6/2026',
  side: 'Buyer'
}, {
  address: '35217 Zachary Way',
  city: 'Beaumont, CA 92223',
  price: '$535,000',
  date: '1/26/2026',
  side: 'Buyer'
}];
const statusStyles: Record<string, string> = {
  'For Sale': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Seller: 'bg-blue-50 text-blue-700 border-blue-200',
  Buyer: 'bg-amber-50 text-amber-700 border-amber-200'
};
export function ActiveListings() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px]" data-id="element-79">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-6 gap-3" data-id="element-80">
        <div data-id="element-81">
          <h2 className="text-2xl font-serif text-brand-dark mb-1" data-id="element-82">
            Active listings & recent sales
          </h2>
          <p className="text-sm text-brand-muted" data-id="element-83">
            Verified from Krystle's{' '}
            <a href="https://www.zillow.com/profile/RothGetsResults" target="_blank" rel="noopener noreferrer" className="text-brand-forest hover:underline inline-flex items-center gap-0.5" data-id="element-84">
              Zillow profile
              <ExternalLink size={11} data-id="element-85" />
            </a>{' '}
            · April 2026 snapshot
          </p>
        </div>
      </div>

      <div className="mb-6" data-id="element-86">
        <p className="text-[11px] font-medium text-brand-muted uppercase tracking-wider mb-2" data-id="element-87">
          For sale ({activeListings.length})
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-88">
          {activeListings.map(l => <div key={l.address} className="p-4 bg-white rounded-xl border border-brand-light hover:border-brand-forest transition-all" data-id="element-89">
              <div className="flex items-center justify-between mb-2" data-id="element-90">
                <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full border leading-tight ${statusStyles[l.status]}`} data-id="element-91">
                  {l.status}
                </span>
              </div>
              <p className="font-mono text-base font-medium text-brand-dark" data-id="element-92">
                {l.price}
              </p>
              <p className="text-sm text-brand-dark" data-id="element-93">{l.address}</p>
              <p className="text-xs text-brand-muted" data-id="element-94">{l.city}</p>
              <div className="flex items-center gap-2 text-[10px] text-brand-muted font-mono mt-1" data-id="element-95">
                <span data-id="element-96">{l.beds} bd</span>
                <span data-id="element-97">{l.baths} ba</span>
              </div>
            </div>)}
        </div>
      </div>

      <div data-id="element-98">
        <p className="text-[11px] font-medium text-brand-muted uppercase tracking-wider mb-2" data-id="element-99">
          Recent closed sales
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-100">
          {recentSales.map(l => <div key={l.address} className="p-3 bg-white rounded-xl border border-brand-light" data-id="element-101">
              <div className="flex items-center justify-between mb-1" data-id="element-102">
                <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full border leading-tight ${statusStyles[l.side]}`} data-id="element-103">
                  Sold · {l.side}
                </span>
                <span className="text-[10px] font-mono text-brand-muted" data-id="element-104">
                  {l.date}
                </span>
              </div>
              <p className="font-mono text-sm font-medium text-brand-dark" data-id="element-105">
                {l.price}
              </p>
              <p className="text-xs text-brand-dark truncate" data-id="element-106">{l.address}</p>
              <p className="text-[10px] text-brand-muted" data-id="element-107">{l.city}</p>
            </div>)}
        </div>
      </div>
    </section>;
}